import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() => ({
  tableHeadRow: {
    background: '#f0f0f0'
  },
  tableHeadCell: {
    textAlign: 'center',
    fontWeight: 'bold'
  },
  tableRowCell: {
    height: '64px',
    textAlign: 'center'
  },
  buttonDetail: {
    color: 'green',
    fontWeight: 'bold'
  }
}));
